
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";
    import {
        ApplicationViewModel, ApprovalStatus, PersonalInfoClient, PersonalInfoRequirementValueViewModel, ApplicationActions,
        PersonalInfoRequirementViewModel, PersonalInfoModel, FileModel, RequirementsClient, ApplicationsClient,
        HistoryDetails
    } from "@/api-client";
    import RequirementProcessingDecision from "@/features/applications/components/RequirementProcessingDecision.vue";
    import moment from "moment";

    @Component({
        components: {RequirementProcessingDecision}
    })
    export default class PersonalInfoRequirementDetails extends Vue {
        @Prop({required: true})
        application!: ApplicationViewModel;
        mutableapplication: ApplicationViewModel = this.application;
        @Prop({required: true})
        actions!: ApplicationActions;

        @Prop({required: true})
        requirement!: PersonalInfoRequirementViewModel;
        mutablerequirement: PersonalInfoRequirementViewModel = this.requirement;

        otherImage?: FileModel | null = null;
        seafarer?: PersonalInfoModel;

        @Prop({required: true})
        requirementValue!: PersonalInfoRequirementValueViewModel;
        mutablerequirementValue: PersonalInfoRequirementValueViewModel = this.requirementValue;
        recentProfileImageChange?: HistoryDetails | null = null;

        approvalStatuses = ApprovalStatus;

        async created(){
            this.seafarer = (await new PersonalInfoClient().get(this.application.seafarerId));
            this.recentProfileImageChange = this.seafarer.recentProfileImageChange;
            if(this.seafarer && this.seafarer.customProfileImages.length > 0 && this.seafarer.officialProfileImages.length > 0){
                this.otherImage = this.mutablerequirementValue.profileImage?.id == this.seafarer.customProfileImages[0].id ? this.seafarer.officialProfileImages[0] :
                (this.mutablerequirementValue.profileImage?.id == this.seafarer.officialProfileImages[0].id ? this.seafarer.customProfileImages[0] : null)
            }
        }



        get age() {
            return moment().diff(this.requirementValue.birthdate, 'years');
        }

        async getImageUrl(imageId: string) {
            return (await new PersonalInfoClient().downloadFile(imageId, this.application.seafarerId)).url
        }

        async chooseImageForRequirement() {
            await new RequirementsClient().setRequirementImage(this.otherImage!,this.application.id,this.requirement.id).then(async result => {
                this.mutableapplication = (await new ApplicationsClient().find(this.mutableapplication.id));
                this.mutablerequirement = this.mutableapplication.requirementFulfillments.find(x => x.requirement instanceof PersonalInfoRequirementViewModel)?.requirement as PersonalInfoRequirementViewModel;
                this.mutablerequirementValue = this.mutableapplication.requirementFulfillments?.find(x => x.requirement instanceof PersonalInfoRequirementViewModel)?.requirementValue! as PersonalInfoRequirementValueViewModel

                if (this.seafarer && this.seafarer.customProfileImages.length > 0 && this.seafarer.officialProfileImages.length > 0) {
                    this.otherImage = this.mutablerequirementValue.profileImage?.id == this.seafarer.customProfileImages[0].id ? this.seafarer.officialProfileImages[0] :
                        (this.mutablerequirementValue.profileImage?.id == this.seafarer.officialProfileImages[0].id ? this.seafarer.customProfileImages[0] : null)
                    this.mutablerequirement.requireProfileImage = false
                    this.$nextTick(() => {
                        this.mutablerequirement.requireProfileImage = true
                    })
                }
            })
        }
    }
